/**
 * Shared helpers for workshop city flow (PDP wizard + state collection + cart).
 */
(function (global) {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function slotBookable(slot) {
    if (!slot) return false;
    var liveApi = global.WorkshopCityEvents;
    if (liveApi && typeof liveApi.isSlotBookable === 'function') {
      return liveApi.isSlotBookable(slot);
    }
    var ds =
      slot.display_status != null && slot.display_status !== ''
        ? String(slot.display_status).toLowerCase()
        : '';
    if (ds) {
      if (ds === 'hidden' || ds === 'ended' || ds === 'sold_out') return false;
      if (ds === 'bookable') {
        var capBookable = slot.capacity_remaining;
        if (capBookable != null && capBookable !== '' && Number(capBookable) <= 0) return false;
        return true;
      }
    }
    var st = String(slot.status || '').toLowerCase();
    if (st === 'sold_out' || st === 'cancelled' || st === 'completed' || st === 'draft') return false;
    var cap = slot.capacity_remaining;
    if (cap != null && cap !== '' && Number(cap) <= 0) return false;
    return true;
  }

  function eventGidFromCartLine(item) {
    if (!item || !item.properties) return '';
    var props = item.properties;
    if (typeof props === 'object' && !Array.isArray(props)) {
      return String(props._event_metaobject_gid || props._event_id || props.event_id || '').trim();
    }
    var gid = '';
    for (var i = 0; i < props.length; i++) {
      var row = props[i];
      if (!row) continue;
      var key = row[0];
      if (key === '_event_metaobject_gid' || key === '_event_id' || key === 'event_id') {
        gid = String(row[1] || '').trim();
        break;
      }
    }
    return gid;
  }

  function seatsInCartForEvent(cart, eventGid) {
    if (!cart || !eventGid) return 0;
    var api = global.WorkshopCityEvents;
    if (api && typeof api.seatsInCartForEvent === 'function') {
      return api.seatsInCartForEvent(eventGid, cart);
    }
    var target = String(eventGid);
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!item) return;
      if (item.properties && item.properties._workshop_addon === 'true') return;
      var gid = eventGidFromCartLine(item);
      if (gid && gid === target) total += item.quantity || 0;
    });
    return total;
  }

  function fetchCartSeatsForEvent(eventGid) {
    var gid = String(eventGid || '').trim();
    if (!gid) return Promise.resolve(0);
    var rootPath = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    return fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        return seatsInCartForEvent(cart, gid);
      });
  }

  function slotDateKey(slot) {
    if (!slot || !slot.date_key) {
      if (slot && slot.schema_start && String(slot.schema_start).length >= 10) {
        return String(slot.schema_start).slice(0, 10);
      }
      return '';
    }
    return String(slot.date_key).slice(0, 10);
  }

  function formatMoney(cents) {
    if (global.Shopify && typeof global.Shopify.formatMoney === 'function') {
      return global.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function buildDaysMap(slots, bookableOnly) {
    var map = {};
    (slots || []).forEach(function (s) {
      var dk = slotDateKey(s);
      if (!dk) return;
      if (!map[dk]) map[dk] = { bookable: false, any: true };
      if (!bookableOnly || slotBookable(s)) {
        if (slotBookable(s)) map[dk].bookable = true;
        map[dk].any = true;
      }
    });
    return map;
  }

  function renderCalendarGrid(opts) {
    var root = opts.root;
    var viewMonth = opts.viewMonth;
    var selectedDate = opts.selectedDate || '';
    var daysWithEvents = opts.daysWithEvents || {};
    var sel = opts.selectors || {};
    var dayAttr = sel.dayAttr || 'data-wcf-cal-day';
    var monthLabel = root.querySelector(sel.monthLabel || '[data-wcf-cal-month-label]');
    var dowEl = root.querySelector(sel.dow || '[data-wcf-cal-dow]');
    var grid = root.querySelector(sel.grid || '[data-wcf-cal-grid]');
    if (!grid) return;

    var y = viewMonth.getFullYear();
    var m = viewMonth.getMonth();
    if (monthLabel) monthLabel.textContent = MONTHS[m] + ' ' + y;
    if (dowEl) {
      dowEl.innerHTML = DOW.map(function (d) {
        return '<span class="wcf-cal-dow">' + d + '</span>';
      }).join('');
    }

    var first = new Date(y, m, 1);
    var startPad = first.getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var html = '';
    var i;
    for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var info = daysWithEvents[key];
      var cls = 'wcf-cal-day';
      if (!info) cls += ' wcf-cal-day--muted';
      else {
        cls += ' wcf-cal-day--has-event';
        if (!info.bookable) cls += ' wcf-cal-day--soldout-only';
      }
      if (selectedDate === key) cls += ' wcf-cal-day--selected';
      var disabled = !info ? ' disabled' : '';
      html +=
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" ' +
        dayAttr +
        '="' +
        key +
        '"' +
        disabled +
        '>' +
        d +
        '</button></span>';
    }
    grid.innerHTML = html;
  }

  function renderPickableCalendarGrid(opts) {
    var root = opts.root;
    var viewMonth = opts.viewMonth;
    var selectedDate = opts.selectedDate || '';
    var sel = opts.selectors || {};
    var dayAttr = sel.dayAttr || 'data-wcf-wl-cal-day';
    var monthLabel = root.querySelector(sel.monthLabel || '[data-wcf-wl-cal-month-label]');
    var dowEl = root.querySelector(sel.dow || '[data-wcf-wl-cal-dow]');
    var grid = root.querySelector(sel.grid || '[data-wcf-wl-cal-grid]');
    if (!grid) return;
    var y = viewMonth.getFullYear();
    var m = viewMonth.getMonth();
    if (monthLabel) monthLabel.textContent = MONTHS[m] + ' ' + y;
    if (dowEl) {
      dowEl.innerHTML = DOW.map(function (d) {
        return '<span class="wcf-cal-dow">' + d + '</span>';
      }).join('');
    }
    var first = new Date(y, m, 1);
    var startPad = first.getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var html = '';
    var i;
    for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var cls = 'wcf-cal-day wcf-cal-day--pickable';
      if (selectedDate === key) cls += ' wcf-cal-day--selected';
      html +=
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" ' +
        dayAttr +
        '="' +
        key +
        '">' +
        d +
        '</button></span>';
    }
    grid.innerHTML = html;
  }

  function getCartSections() {
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        return global.Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (_) {}
    return [];
  }

  function dispatchCartUi(body) {
    try {
      if (body && body.sections && global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        global.Alpine.store('xCartHelper').reRenderSections(body.sections);
      }
    } catch (_) {}
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        var bubble = document.querySelector('#cart-icon-bubble span');
        global.Alpine.store('xCartHelper').currentItemCount = parseInt((bubble && bubble.innerHTML) || '0', 10);
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
    document.dispatchEvent(new CustomEvent('cart:open'));
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart')) {
        if (!global.Alpine.store('xCartNoti') || !global.Alpine.store('xCartNoti').enable) {
          global.Alpine.store('xMiniCart').openCart();
        }
      }
    } catch (_) {}
  }

  function parseUrlParams() {
    try {
      var p = new URLSearchParams(global.location.search);
      return {
        city: (p.get('city') || '').trim().toLowerCase(),
        date: (p.get('date') || '').trim().slice(0, 10),
        step: (p.get('step') || '').trim().toLowerCase(),
      };
    } catch (_) {
      return { city: '', date: '', step: '' };
    }
  }

  function isWeekendDateKey(dateKey) {
    if (!dateKey) return false;
    var d = new Date(dateKey + 'T12:00:00');
    if (isNaN(d.getTime())) return false;
    var dow = d.getDay();
    return dow === 0 || dow === 6;
  }

  function isWithinNextDays(dateKey, days) {
    if (!dateKey) return false;
    var d = new Date(dateKey + 'T12:00:00');
    if (isNaN(d.getTime())) return false;
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var end = new Date(now);
    end.setDate(end.getDate() + days);
    return d >= now && d <= end;
  }

  function filterSlots(slots, filters) {
    filters = filters || {};
    return (slots || []).filter(function (s) {
      var dk = slotDateKey(s);
      if (filters.availableOnly && !slotBookable(s)) return false;
      if (filters.thisWeekend && !isWeekendDateKey(dk)) return false;
      if (filters.next7Days && !isWithinNextDays(dk, 7)) return false;
      return true;
    });
  }

  function mergeCityMeta(city, metaByHandle) {
    if (!city || !metaByHandle) return city;
    var m = metaByHandle[city.product_handle];
    if (!m) return city;
    if (!city.featured_image_url && m.featured_image_url) city.featured_image_url = m.featured_image_url;
    if (!city.product_url && m.product_url) city.product_url = m.product_url;
    if (!city.city_name && m.city_name) city.city_name = m.city_name;
    if (!city.venue_name && m.venue_name) city.venue_name = m.venue_name;
    if (m.latitude != null) city.latitude = m.latitude;
    if (m.longitude != null) city.longitude = m.longitude;
    if (!city.title && m.title) city.title = m.title;
    return city;
  }

  function formatWaitlistError(body) {
    if (!body) return '';
    if (Array.isArray(body.errors) && body.errors.length) {
      return body.errors
        .map(function (e) {
          if (!e) return '';
          return e.message ? String(e.message) : String(e.field || '');
        })
        .filter(Boolean)
        .join(' ');
    }
    if (body.message && body.message !== body.error) return String(body.message);
    if (body.description) return String(body.description);
    if (body.error && body.error !== 'VALIDATION_ERROR') return String(body.error);
    return '';
  }

  function normalizeWaitlistSource(source) {
    var s = String(source || '').trim();
    if (s === 'api_error') return 'no_events';
    return s || 'no_events';
  }

  function slugifyVenueId(text) {
    return String(text || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function resolveWaitlistVenueId(root, data) {
    if (!root || !root.getAttribute) {
      return String((data && data.productHandle) || '').trim();
    }
    var fromAttr = String(root.getAttribute('data-venue-id') || '').trim();
    if (fromAttr) return fromAttr;
    var city = String(root.getAttribute('data-city-name') || '').trim();
    var state = String(root.getAttribute('data-state-name') || '').trim();
    var fromCityState = slugifyVenueId(city && state ? city + '-' + state : city || state);
    if (fromCityState) return fromCityState;
    var venueName = String(root.getAttribute('data-venue-name') || '').trim();
    var fromVenue = slugifyVenueId(venueName);
    if (fromVenue) return fromVenue;
    return String((data && data.productHandle) || root.getAttribute('data-product-handle') || '').trim();
  }

  function normalizeEventStatus(slot) {
    var st = String((slot && slot.status) || 'active')
      .trim()
      .toLowerCase();
    if (!st) return 'active';
    if (st === 'cancelled') return 'completed';
    if (st === 'started') return 'active';
    return st;
  }

  /**
   * Line item properties (_event_id, _capacity_remaining, _event_status) support audit/UX.
   * Checkout enforcement uses shop metafield snapshot via aogen.checkout_event_snapshot Function.
   */
  function appendCartValidationProperties(slot, props) {
    if (!props) props = {};
    if (!slot) return props;

    var gid = String(slot.gid || slot.event_metaobject_gid || '').trim();
    if (!gid && slot._raw) {
      gid = String(slot._raw.gid || slot._raw.id || slot._raw.event_metaobject_gid || '').trim();
    }
    if (gid) {
      props._event_id = gid;
      props._event_metaobject_gid = gid;
    }

    var raw = slot._raw && typeof slot._raw === 'object' ? slot._raw : {};
    var groupId = String(slot.capacity_group_id || raw.capacity_group_id || '').trim();
    var canonicalId = String(slot.canonical_event_id || raw.canonical_event_id || '').trim();
    if (groupId) props._capacity_group_id = groupId;
    else if (canonicalId) props._capacity_group_id = canonicalId;
    if (canonicalId) props._canonical_event_id = canonicalId;

    if (slot.capacity_remaining != null && slot.capacity_remaining !== '') {
      var cap = Number(slot.capacity_remaining);
      if (Number.isFinite(cap) && cap >= 0) {
        props._capacity_remaining = String(Math.floor(cap));
        props._capacity_source = 'live_state';
      }
    }

    if (slot.display_status != null && slot.display_status !== '') {
      props._display_status = String(slot.display_status);
    }
    if (slot.capacity_as_of != null && slot.capacity_as_of !== '') {
      props._capacity_as_of = String(slot.capacity_as_of);
    }

    props._event_status = normalizeEventStatus(slot);
    return props;
  }

  function resolveWorkshopType(root, data) {
    var fromAttr = root && root.getAttribute ? String(root.getAttribute('data-workshop-type') || '').trim().toLowerCase() : '';
    if (fromAttr === 'mosaic' || fromAttr === 'ceramic' || fromAttr === 'resin') return fromAttr;
    var handle = String((data && data.productHandle) || (root && root.getAttribute('data-product-handle')) || '').toLowerCase();
    var title = root && root.getAttribute ? String(root.getAttribute('data-product-title') || '').toLowerCase() : '';
    if (handle.indexOf('ceramic') >= 0 || title.indexOf('ceramic') >= 0) return 'ceramic';
    if (handle.indexOf('resin') >= 0 || title.indexOf('resin') >= 0) return 'resin';
    if (handle.indexOf('mosaic') >= 0 || title.indexOf('mosaic') >= 0) return 'mosaic';
    return 'mosaic';
  }

  function submitWaitlist(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
    }).then(function (res) {
      return res.json().then(function (body) {
        return { ok: res.ok, status: res.status, body: body || {} };
      }).catch(function () {
        return res.text().then(function (txt) {
          return { ok: res.ok, status: res.status, body: { description: txt } };
        });
      });
    }).then(function (r) {
      if (!r.ok) {
        var msg = formatWaitlistError(r.body) || 'Request failed (' + r.status + ')';
        throw new Error(msg);
      }
      if (r.body && r.body.success === false) {
        throw new Error(formatWaitlistError(r.body) || 'Could not add to waitlist.');
      }
      return r.body;
    });
  }

  global.WorkshopCityFlow = {
    MONTHS: MONTHS,
    DOW: DOW,
    slotBookable: slotBookable,
    slotDateKey: slotDateKey,
    formatMoney: formatMoney,
    buildDaysMap: buildDaysMap,
    renderCalendarGrid: renderCalendarGrid,
    renderPickableCalendarGrid: renderPickableCalendarGrid,
    getCartSections: getCartSections,
    dispatchCartUi: dispatchCartUi,
    parseUrlParams: parseUrlParams,
    filterSlots: filterSlots,
    mergeCityMeta: mergeCityMeta,
    isWeekendDateKey: isWeekendDateKey,
    formatWaitlistError: formatWaitlistError,
    normalizeWaitlistSource: normalizeWaitlistSource,
    resolveWaitlistVenueId: resolveWaitlistVenueId,
    resolveWorkshopType: resolveWorkshopType,
    appendCartValidationProperties: appendCartValidationProperties,
    eventGidFromCartLine: eventGidFromCartLine,
    seatsInCartForEvent: seatsInCartForEvent,
    fetchCartSeatsForEvent: fetchCartSeatsForEvent,
    submitWaitlist: submitWaitlist,
  };
})(typeof window !== 'undefined' ? window : this);
